import React from 'react';
import { CustomizedTypography } from '@components/Customized';

import useStyles from './useStyles';
import { CapaQuotationRfqPurchaseOrder } from '@generated/graphql';

const PurchaseOrderDraftEditCondition = ({
  renderDivider,
  currentItem
}: {
  renderDivider: () => React.ReactNode;
  currentItem?: CapaQuotationRfqPurchaseOrder;
}) => {
  const classes = useStyles();

  const maxDraftModificationCount = currentItem?.maxDraftModificationCount ?? 0;

  const draftModificationTerms = currentItem?.draftModificationTerms ?? '';

  if (maxDraftModificationCount === 0) return null;

  return (
    <>
      <div className={classes.wrapper + ' gutter'}>
        <CustomizedTypography variant="h4" fontWeight="500" gutterBottoms={8}>
          시안 수정 조건
        </CustomizedTypography>

        <CustomizedTypography
          variant={'body1'}
          color="primary"
          fontWeight="500"
        >
          최대 {maxDraftModificationCount}회까지
        </CustomizedTypography>

        <CustomizedTypography variant="body1" className="pre-line">
          {draftModificationTerms}
        </CustomizedTypography>
      </div>
      {renderDivider()}
    </>
  );
};

export default PurchaseOrderDraftEditCondition;
